module.exports = __webpack_public_path__ + "img/hopways-02.be7cfd14.webp";